export enum TRIAL_DETAILS {
  PERIOD_IN_DAYS = 14,
  UNIT = 'day', // https://day.js.org/docs/en/display/difference#list-of-all-available-units
}

export default TRIAL_DETAILS
